import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { Form, Input } from 'formsy-semantic-ui-react';
import { addValidationRule } from 'formsy-react';
import styled from 'styled-components';
import { Flex, Box } from 'rebass';
import { diff } from 'deep-object-diff';
import _throttle from 'lodash/throttle';
import _reduce from 'lodash/reduce';
import isNumber from 'is-number';
import ReactGA from 'react-ga';

import { Text } from '../Base';
import { COLOR, FONT_SIZE, SPACE } from '../Theme';
import { formatScore } from '../Base/Number/utils';

const SInput = styled(Input)`
  .input {
    display: flex;
    flex-direction: row-reverse;
    input {
      flex: 0 0 160px;
      width: 100% !important;
      text-align: right !important;
      padding: 0.478571em 0.6em !important;
      line-height: 1.42 !important;
      &::placeholder {
        text-align: right;
      }
      &:focus {
        border-color: ${COLOR.primary} !important;
      }
    }
  }
`;

const SButton = styled(Button)`
  flex: 1 1 auto;
  margin-right: 0 !important;
`;

addValidationRule('isExamScore', (values, value, maxScore) => {
  const result = value ? value >= 0 && value <= maxScore : true;
  return result;
});

const getExamScoreError = maxScore => {
  return 'กรุณากรอกคะแนนให้ถูกต้อง' + (maxScore ? ` (ไม่เกิน ${maxScore})` : '');
};

const cleanNumberForProps = score => {
  let result;
  if (isNumber(score)) {
    result = formatScore(score);
  }
  return result;
};

const generateField = (name, label, placeholder, maxScore = 300, initialValue) => {
  return (
    <Flex mb={3}>
      <Flex width={3 / 5} pt={'6px'} pr={SPACE.small}>
        <Text fontWeight="500" fontSize={FONT_SIZE.normal}>
          {label || name}
        </Text>
      </Flex>
      <Flex width={2 / 5} justifyContent="flex-end">
        <SInput
          name={`${name}`}
          // type="number"
          // inline
          placeholder={placeholder}
          validations={{ isExamScore: maxScore, isFloat: true }}
          // validations={{ isFloat: true }}
          validationErrors={{
            isExamScore: getExamScoreError(maxScore),
            // maxLength: 'กรุณากรอกทศนิยมไม่เกิน 2 ตำแหน่ง และไม่มี 0 นำหน้า',
          }}
          errorLabel={errorLabel}
          value={cleanNumberForProps(initialValue)}
        />
      </Flex>
    </Flex>
  );
};

// const errorLabel = <Label color="red" pointing="right" />;
const errorLabel = <Text color="danger" textAlign="right" />;

class ScoreForm extends Component {
  static propTypes = {
    exams: PropTypes.array,
    onSubmit: PropTypes.func,
    placeholder: PropTypes.string,
    myScores: PropTypes.object,
    submitText: PropTypes.string,
    submitLoading: PropTypes.bool,
    onSubmitted: PropTypes.func,
  };

  static defaultProps = {
    exams: [],
    onSubmit: () => {},
    placeholder: 'ใส่คะแนนเลย',
    myScores: {},
    submitText: 'คำนวณคะแนน',
    submitLoading: false,
    onSubmitted: () => {},
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.submitLoading === true && nextProps.submitLoading === false) {
      this.props.onSubmitted();
    }
  }

  handleSubmit = _throttle(formData => {
    // console.log('ScoreForm handleSubmit:', formData);
    if (!this.props.submitLoading) {
      const filledData = _reduce(
        formData,
        (result, value, key) => {
          if (![undefined, null, 'undefined', 'null', 'NULL'].includes(value)) {
            result[key] = +value;
          }
          return result;
        },
        {}
      );
      const diffScoreData = diff(this.props.myScores, filledData);
      if (Object.entries(diffScoreData).length > 0) {
        try {
          ReactGA.event({
            category: 'EXAM_SCORE',
            action: 'Save score',
          });
        } catch (err) {
          console.log('ga error:', err);
        }
        this.props.onSubmit(diffScoreData);
      } else {
        setTimeout(() => {
          try {
            ReactGA.event({
              category: 'EXAM_SCORE',
              action: 'Save score',
              label: 'no score diff',
            });
          } catch (err) {
            console.log('ga error:', err);
          }
          this.props.onSubmitted();
        }, 200);
      }
    }
  }, 1000);

  render() {
    const {
      exams,
      placeholder,
      myScores,
      submitText,
      submitLoading,
      myMockExamScores,
    } = this.props;

    const scores = { ...myScores, ...myMockExamScores };
    return (
      <Form
        onValidSubmit={this.handleSubmit}
        // onInvalidSubmit={model => {
        //   console.log('onInvalidSubmit model:', model);
        // }}
      >
        {exams.map((ex, idx) => (
          <Fragment key={`field_${idx}`}>
            {generateField(ex.id, ex.title, placeholder, ex.fullScore, scores[ex.id])}
          </Fragment>
        ))}
        <Flex pt={2}>
          <SButton primary type="submit" loading={submitLoading}>
            {submitText}
          </SButton>
        </Flex>
      </Form>
    );
  }
}

export default ScoreForm;
